import { UNSET_COLUMN_SIZE } from '../constants';
import { SystemTPColumnKey, TPColumnKey } from '../types';

export function getDefaultColumnSize(column: TPColumnKey | SystemTPColumnKey): number {
  if (column === 'address') return 200;
  return UNSET_COLUMN_SIZE;
}
